import { apiUrl, getByAxios } from "./axios.js"

export function getUploadParameters (file) {
  const filename = file.name
  const { type } = file['type']

  const query = new URLSearchParams({ filename, type })

  return getByAxios(require('axios'), `/s3/params?${query}`)
}